"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromObject = exports.from = void 0;
const EnumerableFactory_1 = require("../utilities/EnumerableFactory");
const applyFrom_1 = require("./applicators/applyFrom");
/**
 * Creates a new Enumerable from the input Iterable.
 * @example
 * ```typescript
 * const numbers = [1, 2, 3, 4];
 * const enumerable = from(numbers);
 * ```
 * @typeparam TSource The type of the Iterable.
 * @param src The Iterable to create an Enumerable from.
 * @returns A new Enumerable.
 */
function from(src) {
    return (0, applyFrom_1.applyFrom)(new EnumerableFactory_1.EnumerableFactory(), src);
}
exports.from = from;
/**
 * Creates a new Enumerable from the input Iterable.
 * @example
 * ```typescript
 * const obj = { foo: 'bar' };
 * const enumerable = from(obj);
 * ```
 * @typeparam TSource The type of the object.
 * @param src The object to create an Enumerable from.
 * @returns A new Enumerable.
 */
function fromObject(src) {
    return (0, applyFrom_1.applyFrom)(new EnumerableFactory_1.EnumerableFactory(), src);
}
exports.fromObject = fromObject;
//# sourceMappingURL=from.js.map